var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcTorusKnot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14838 11.5952C5.0817 11.7953 4.82829 12.2751 5.1484 12.5952C5.74864 13.1954 7.14912 12.9953 8.14946 12.1951C8.89386 11.5995 9.86908 10.2077 10.27 9.5332",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94946 5.402C9.53877 5.402 10.0165 4.59584 10.0165 3.60139C10.0165 2.60694 9.53877 1.80078 8.94946 1.80078",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5994 11.8652C16.5994 11.2759 15.7932 10.7982 14.7988 10.7982C13.8043 10.7982 12.9982 11.2759 12.9982 11.8652",
    stroke: "#B7B7B7",
    strokeWidth: 0.7,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9508 11.3957C12.7908 11.8759 12.3843 12.5146 12.2011 12.7739C11.056 14.2372 9.92144 15.0801 9.49731 15.3187C8.0476 16.0117 4.62801 16.8776 2.54731 14.7969C0.03052 12.2801 2.19719 7.8899 3.79028 7.24609",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12395 11.6621L5.91919 12.7758L5.91794 12.7758C5.6429 12.7758 5.31943 12.7758 5.12395 12.5372C4.92817 12.2983 4.99141 11.7946 5.12395 11.6621Z",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03542 11.6016C5.03542 11.0123 4.22926 10.5345 3.23481 10.5345C2.24036 10.5345 1.4342 11.0123 1.4342 11.6016",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98812 5.7945C9.68523 5.48088 9.3181 5.39584 9.14961 5.3959C8.61607 5.32921 7.50897 5.59596 7.34891 7.19651C7.2001 8.68463 8.30806 10.2881 9.00044 11.042",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8962 7.09308C13.9076 5.97445 13.7131 4.86861 13.151 3.99427C11.7105 1.75351 8.81622 1.65401 7.54912 1.92076C5.64418 2.32181 3.54776 4.19434 3.9479 7.79556C4.25512 10.5606 5.56982 12.3182 6.26471 12.9268",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9491 9.39654C8.68268 9.19647 10.51 9.07643 11.9505 10.1968C13.3909 11.3172 13.2175 12.2642 12.9508 12.5976C12.7799 12.8113 12.5214 12.9519 12.1503 12.9883",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74902 5.99562C8.34923 5.92893 10.1899 5.71566 11.9504 6.19583C14.1512 6.79603 15.8163 8.52731 16.4394 10.3966C17.0396 12.1972 16.0639 14.2613 14.7514 15.1989C13.3509 16.1992 11.3502 16.3987 9.34957 15.3983",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTorusKnot);
export default __webpack_public_path__ + "static/media/ic_torus_knot.dfa65c2e6a4a4131e6529ab2dac3bf7d.svg";
export { ForwardRef as ReactComponent };